/**
 * ctrLpLazyVideo — loads and plays a muted background video only while it is in view.
 * Mirrors ctr-section-image-text-icon.js, scoped to one element so a page can hold many.
 *
 * Usage:
 *   <div x-data="ctrLpLazyVideo">
 *     <video x-ref="video" muted playsinline loop preload="none">
 *       <source data-src="..." type="video/mp4">
 *     </video>
 *   </div>
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('ctrLpLazyVideo', () => ({
    observer: null,

    init() {
      const video = this.$refs.video;
      if (!video || window.__ultraShouldSuppressVideo === true) return;

      video.muted = true;
      video.playsInline = true;

      if (!('IntersectionObserver' in window)) {
        this.play();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.play();
            else video.pause();
          });
        },
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(video);
    },

    destroy() {
      if (this.observer) this.observer.disconnect();
    },

    loadSources() {
      const video = this.$refs.video;
      if (video.dataset.sourcesReady === 'true') return;

      let needsLoad = false;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          needsLoad = true;
        }
      });

      if (needsLoad) {
        try {
          video.load();
        } catch (error) {}
      }
      video.dataset.sourcesReady = 'true';
    },

    play() {
      if (window.__ultraShouldSuppressVideo === true) return;
      this.loadSources();
      const playPromise = this.$refs.video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    },
  }));
});
